import { $host } from "./index";

export const postMailing = async (mailing) => {
    const {data} = await $host.post('web/mailing', mailing);
    return data;
}

export const getMailingHistory = async (params) => {
    const { data } = await $host.post('web/mailing/history', { params });
    return data;
};

export const getEventMessageById = async (id) => {
    const { data } = await $host.get(`web/event_message/${id}`);
    return data;
};
export const postAutoMailing = async (mailing) => {
    const { data } = await $host.post('web/event_message', mailing);
    return data;
};

export const getAllEventMessagesByClinicId = async () => { // Убрали параметр
    const { data } = await $host.get('web/event_message'); // Изменили URL
    return data;
};

export const deleteEventMessageById = async (id) => {
    const { data } = await $host.delete(`web/event_message/${id}`);
    return data;
};

export const updateEventMessageById = async (id, updatedData) => {
    const { data } = await $host.patch(`web/event_message/${id}`, updatedData);
    return data;
};